export default __webpack_public_path__ + "static/media/remodel8.01c14762.png";